// Footer Component
const Footer = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2023;
    const yearDisplay = currentYear > startYear ? `${startYear}-${currentYear.toString().slice(-2)}` : startYear;

    return (
        <footer id="footer">
            <div id="copyrights">
                <div className="container">
                    <div className="row justify-content-between col-mb-30">
                        <div className="col-12 col-md-auto text-center text-md-start">
                            Copyrights © {yearDisplay} All Rights Reserved by <strong>Dsign Palette</strong><br />
                            <div className="copyright-links">
                                <a href="#">Terms of Use</a> / <a href="#">Privacy Policy</a>
                            </div>
                        </div>

                        <div className="col-12 col-md-auto">
                            <div className="d-flex justify-content-center justify-content-md-end">
                                <a href="#" className="social-icon rounded-circle si-small bg-light h-bg-facebook">
                                    <i className="fa-brands fa-facebook-f"></i>
                                    <i className="fa-brands fa-facebook-f"></i>
                                </a>

                                <a href="#" className="social-icon rounded-circle si-small bg-light h-bg-twitter">
                                    <i className="fa-brands fa-twitter"></i>
                                    <i className="fa-brands fa-twitter"></i>
                                </a>

                                <a href="#" className="social-icon rounded-circle si-small bg-light h-bg-instagram">
                                    <i className="fa-brands fa-instagram"></i>
                                    <i className="fa-brands fa-instagram"></i>
                                </a>

                                <a href="#" className="social-icon rounded-circle si-small bg-light h-bg-linkedin me-0">
                                    <i className="fa-brands fa-linkedin"></i>
                                    <i className="fa-brands fa-linkedin"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
export default Footer;